import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { Input, Select } from "antd";
import { AreaEnum } from "@/types/user";
import { AREA_CODES } from "@/utils/const";

const { Option } = Select;

const UserMobile:FC<{
  areaCode: AreaEnum,
  setAreaCode: React.Dispatch<React.SetStateAction<AreaEnum>>
  mobile: string,
  setMobile: React.Dispatch<React.SetStateAction<string>>
}> = ({ areaCode, setAreaCode, mobile, setMobile }) => {
  const { t } = useTranslation();

  const prefixSelector = (
    <Select
      value={areaCode}
      onChange={setAreaCode}
      style={{ width: 80 }}
      popupMatchSelectWidth={false}
      labelRender={(label) => label.value}
    >
      {AREA_CODES.map((area) => (
        <Option
          key={area.code}
          value={area.code}
        >{`${area.code} ${area.area}`}</Option>
      ))}
    </Select>
  );

  return (
    <Input
      value={mobile}
      onChange={(e) => setMobile(e.target.value.trim())}
      placeholder={t('login.enterAcnt')}
      addonBefore={prefixSelector}
    />
  );
}

export default UserMobile;
